import React from 'react';

/**
 * Top-level ErrorBoundary — catches any render-time crash in a page or
 * component tree and shows a clean fallback panel instead of a white screen
 * with an uncaught runtime error overlay. Keeps the rest of the app (sidebar,
 * chat widget, etc.) navigable so the operator can recover with one click.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(err) {
    return { err };
  }
  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error('ATDE boundary caught:', err, info?.componentStack);
  }
  reset = () => this.setState({ err: null });
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="p-6 font-mono text-[12px] space-y-2">
        <div className="text-sell uppercase tracking-[0.35em] text-[12px] font-display">
          // panel render error
        </div>
        <div className="text-[var(--txt-secondary)]">
          A component threw while rendering. The rest of the app is unaffected — use the sidebar to navigate to another tab, or retry below.
        </div>
        <pre className="text-[11px] text-sell bg-black border border-[var(--border-default)] p-2 max-w-[90ch] whitespace-pre-wrap">
          {String(this.state.err?.message || this.state.err)}
        </pre>
        <button
          data-testid="errorboundary-retry"
          onClick={this.reset}
          className="border border-cyan-sys text-cyan-sys px-3 py-1 hover:bg-cyan-sys hover:text-black uppercase tracking-[0.3em] text-[11px]"
        >
          retry panel
        </button>
      </div>
    );
  }
}
